import { render } from "./CtaButton.vue?vue&type=template&id=4622b797&scoped=true"
import script from "./CtaButton.vue?vue&type=script&lang=js"
export * from "./CtaButton.vue?vue&type=script&lang=js"

import "./CtaButton.vue?vue&type=style&index=0&id=4622b797&lang=scss&scoped=true"
import "./CtaButton.vue?vue&type=style&index=1&id=4622b797&lang=scss&global=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4622b797"],['__file',"src/scripts/view/publicPages/components/CtaButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4622b797"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4622b797', __exports__)) {
    api.reload('4622b797', __exports__)
  }
  
  module.hot.accept("./CtaButton.vue?vue&type=template&id=4622b797&scoped=true", () => {
    api.rerender('4622b797', render)
  })

}


export default __exports__